module.exports = __webpack_public_path__ + "static/media/syringe.98824610.svg";